import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

const InfoPageLink = ({ id, children, nodes: pages, className, url }) => {
  const page = pages.find(p => p.id === id);

  const pathName = url || page?.pathName;

  if (!pathName) {
    return null;
  }
  return (
    <Link
      className={className}
      to={pathName}
      onClick={() =>
        trackInternalNavigationClick({
          scope: InternalNavigationScope.ABOUT_REVIEWS,
          nextPage: pathName,
        })
      }
    >
      {children}
    </Link>
  );
};

const { number, node, arrayOf, shape, string } = PropTypes;

InfoPageLink.propTypes = {
  id: number,
  children: node,
  nodes: arrayOf(
    shape({
      id: number.isRequired,
      pathName: string.isRequired,
    })
  ),
  className: string,
  url: string,
};

InfoPageLink.defaultProps = {
  children: undefined,
  id: null,
  nodes: [],
  className: undefined,
  url: undefined,
};

export default connect(state => state.globals.infoPages)(InfoPageLink);
